var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-content-table-outline",
    _vm._g(
      {
        attrs: {
          title: _vm.title,
          "comment-highlights": _vm.commentHighlights,
          "highlight-mode": _vm.highlightMode,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "sub" },
                  _vm._l(_vm.contents, function (content, i) {
                    return _c("job-content-table-sub", {
                      key: "content-" + i,
                      staticClass: "pega-break",
                      attrs: {
                        "target-id": _vm.targetIds[i],
                        content: content,
                      },
                    })
                  }),
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }